import { DISPLAY_SHARED_RESOURCES, SELECT_SHARED_RESOURCES_TO_DOWNLOAD, UPDATE_SHARED_RESOURCES } from '../../../types/conversations/plugins'

const initialSharedResourcesHistory = {
  isOpen: false,
  isLoading: false,
  sharedResources: [],
  sharedResourcesToDownload: [],
}


export default function sharedResourcesHistory(state = initialSharedResourcesHistory, action) {
  switch (action.type) {
    case DISPLAY_SHARED_RESOURCES: {
      const { isOpen, isLoading } = action
      return Object.assign({}, state, { isOpen, isLoading })
    }
    case UPDATE_SHARED_RESOURCES: {
      const { sharedResources } = action
      return Object.assign({}, state, { isLoading: false, sharedResources })
    }
    case SELECT_SHARED_RESOURCES_TO_DOWNLOAD: {
      const { sharedResourcesToDownload } = action
      return Object.assign({}, state, { sharedResourcesToDownload })
    }
    default: {
      return state
    }
  }
}
